import React, { useEffect } from 'react';
import { useGetState } from 'ahooks';
import { Button } from 'antd-mobile';
import { storagePrefixV2 } from '@/constant';
import { setIsTipsPlayOK } from '../../store/useAIDiagnoseStore';

import cx from './index.module.scss';

interface Props {}

const TipsPage: React.FC<Props> = () => {
  const [bottom, setBottom, getBottom] = useGetState(-75);

  useEffect(() => {
    const timer = setInterval(() => {
      if (getBottom() < 0) {
        setBottom(getBottom() + 25);
      } else {
        clearInterval(timer);
        setIsTipsPlayOK(true);
      }
    }, 1500);
    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cx('TipsPage')}>
      <div className={cx('content-wrapper')}>
        <div className={cx('text-container')}>
          <div className={cx('text-wrapper')} style={{ bottom: `${bottom}%` } as any}>
            <div
              style={{ opacity: 75 + bottom == 0 ? 1 : 75 + bottom <= 25 ? 0.65 : 75 + bottom <= 50 ? 0.4 : 0.2 }}
              className={cx('text-item')}
            >
              亲爱的会员
            </div>
            <div
              style={{ opacity: 75 + bottom == 0 ? 0 : 75 + bottom <= 25 ? 1 : 75 + bottom <= 50 ? 0.65 : 0.4 }}
              className={cx('text-item')}
            >
              通过AI问询
            </div>
            <div
              style={{ opacity: 75 + bottom == 0 ? 0 : 75 + bottom <= 25 ? 0 : 75 + bottom <= 50 ? 1 : 0.4 }}
              className={cx('text-item')}
            >
              您将更了解自己的身体
            </div>
            <div
              style={{ opacity: 75 + bottom == 0 ? 0 : 75 + bottom <= 25 ? 0 : 75 + bottom <= 50 ? 0 : 1 }}
              className={cx('text-item')}
            >
              并获得您专属的智能问询报告
            </div>
          </div>
        </div>
        <div className={cx('img-wrapper')}>
          <img src={storagePrefixV2 + '/tips-logo-min.png'} alt="" />
        </div>
        <Button color="primary" block className={cx('btn')} onClick={() => setIsTipsPlayOK(true)}>
          跳过
        </Button>
      </div>
    </div>
  );
};

export default TipsPage;
